import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import BreadcrumbAnchor from './BreadcrumbAnchor';
import BreadcrumbSpan from './BreadcrumbSpan';
import { calculateRem } from '@uie/javascript-style-helpers';
import { IconData } from '@vds-core/icons';
import Icon from '@vds-core/icons';
import { colors } from '@vds-core/theme';
import { BodyConfig, TypographyConfig } from '@vds-core/typography';
var propTypes = {
  /**
   * @deprecated ariaLabel
   */
  label: PropTypes.string,
  //DEPRECATED

  /**
   * @deprecated href
   */
  url: PropTypes.string,
  //DEPRECATED

  /**
   * Value to be set on the target Attribute of the a tag.
   */
  target: PropTypes.string,

  /**
   * If active = false on last breadcrumb it will not render with active styles
   */
  active: PropTypes.bool,

  /**
   * If provided, the Breadcrumb will be rendered as a span that is not clickable.
   */
  disabled: PropTypes.bool,

  /**
   * Contents to be displayed in the a tag.
   */
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,

  /**
   * @deprecated
   */
  className: PropTypes.string,

  /**
   * If provided, used as string that labels the element for accessibility.
   */
  ariaLabel: PropTypes.string,

  /**
   * href to be set as the value of the href Attribute in the a tag.
   */
  href: PropTypes.string.isRequired,

  /**
   * @ignore
   * this is the amount of spacing on bottom of breadcrumbs
   */
  margin: PropTypes.string,

  /**
   * @ignore
   * this is the amount of spacing between label and icon
   */
  iconSpacing: PropTypes.string,

  /**
   * @ignore
   */
  bodyConfig: PropTypes.object,

  /**
   * @ignore
   * this turns the focus box on or off
   */
  focusState: PropTypes.bool,

  /**
   * @ignore
   */
  typescale: PropTypes.string,

  /**
   * @ignore
   */
  iconConfig: PropTypes.object,

  /**
   * @ignore
   */
  colorConfig: PropTypes.object,

  /**
   * @ignore
   */
  inverted: PropTypes.bool,

  /**
   * Allows a string to be provided for analytics.
   */
  'data-analyticstrack': PropTypes.string,

  /**
   * Allows a string to be provided for analytics.
   */
  'data-track': PropTypes.string,

  /**
   * Allows a string to be provided for click stream.
   */
  'data-clickstream': PropTypes.string
};
var defaultProps = {
  active: null,
  disabled: null,
  target: '_self',
  className: null,
  typescale: TypographyConfig.getTypescale(),
  colorConfig: colors,
  iconConfig: IconData,
  margin: calculateRem(0),
  iconSpacing: calculateRem(2),
  focusState: false,
  bodyConfig: BodyConfig,
  inverted: false
};
var StyledBreadcrumb = /*#__PURE__*/styled.li.withConfig({
  displayName: "StyledBreadcrumb",
  componentId: "sc-1m8yc9v-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  align-items: center;\n  color: ", ";\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: center;\n  margin-bottom: ", "px;\n  margin-top: ", "px;\n"])), function (_ref) {
  var inverted = _ref.inverted,
      colorConfig = _ref.colorConfig;
  return inverted ? colorConfig.white : colorConfig.coolGray6;
}, function (_ref2) {
  var margin = _ref2.margin;
  return margin / 2;
}, function (_ref3) {
  var margin = _ref3.margin;
  return margin / 2;
});
var IconWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "IconWrapper",
  componentId: "sc-1m8yc9v-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  padding-right: ", ";\n  padding-left: ", ";\n  display: flex;\n  align-items: center;\n  outline: none;\n"])), function (_ref4) {
  var iconSpacing = _ref4.iconSpacing;
  return iconSpacing;
}, function (_ref5) {
  var iconSpacing = _ref5.iconSpacing;
  return iconSpacing;
}); // const BreadcrumbItem = props => {

export var BreadcrumbItem = /*#__PURE__*/function (_Component) {
  _inherits(BreadcrumbItem, _Component);

  var _super = _createSuper(BreadcrumbItem);

  function BreadcrumbItem() {
    _classCallCheck(this, BreadcrumbItem);

    return _super.apply(this, arguments);
  }

  _createClass(BreadcrumbItem, [{
    key: "renderIcon",
    value:
    /*
     * If the BreadCrumb is active or disabled, it should be a <span>, otherwise it should be an <a>
     * <a> tags cannot truly be "disabled", so using a <span> increases accessibility
     */
    function renderIcon() {
      var _this$props = this.props,
          colorConfig = _this$props.colorConfig,
          iconConfig = _this$props.iconConfig,
          iconSpacing = _this$props.iconSpacing,
          inverted = _this$props.inverted,
          tabIndex = _this$props.tabIndex;
      var color = inverted ? colorConfig.white : colorConfig.black;
      return /*#__PURE__*/React.createElement(IconWrapper, {
        iconSpacing: iconSpacing,
        "aria-hidden": true,
        tabIndex: -1
      }, /*#__PURE__*/React.createElement(Icon, {
        "aria-hidden": true,
        color: color,
        data: iconConfig,
        name: "caret-right",
        size: "extraSmall",
        tabIndex: -1
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          active = _this$props2.active,
          label = _this$props2.label,
          children = _this$props2.children,
          className = _this$props2.className,
          ariaLabel = _this$props2.ariaLabel,
          lastChild = _this$props2.lastChild,
          margin = _this$props2.margin,
          iconSpacing = _this$props2.iconSpacing,
          bodyConfig = _this$props2.bodyConfig,
          focusState = _this$props2.focusState,
          typescale = _this$props2.typescale,
          iconConfig = _this$props2.iconConfig,
          colorConfig = _this$props2.colorConfig,
          inverted = _this$props2.inverted,
          analyticsTrack = _this$props2['data-analyticstrack'],
          track = _this$props2['data-track'],
          clickStream = _this$props2['data-clickstream'],
          cta = _this$props2['data-sitecat-cta'],
          dataTrack = _this$props2['data-sitecat-datatrack'],
          position = _this$props2['data-sitecat-position'],
          level = _this$props2['data-sitecat-level'];
      var BreadcrumbComponent = active && lastChild || this.props.disabled ? BreadcrumbSpan : BreadcrumbAnchor;

      var breadcrumbComponentProps = _objectSpread(_objectSpread({}, this.props), {}, {
        className: ''
      });

      return /*#__PURE__*/React.createElement(StyledBreadcrumb, {
        className: className,
        colorConfig: colorConfig,
        inverted: inverted,
        margin: margin
      }, /*#__PURE__*/React.createElement(BreadcrumbComponent, _extends({}, breadcrumbComponentProps, {
        label: label,
        ariaLabel: ariaLabel,
        tabIndex: 1,
        bodyConfig: bodyConfig,
        focusState: focusState,
        typescale: typescale,
        colorConfig: colorConfig,
        "data-analyticstrack": analyticsTrack,
        "data-track": track,
        "data-clickstream": clickStream,
        cta: cta,
        level: level,
        position: position,
        dataTrack: dataTrack,
        inverted: inverted
      }), children), !active && !lastChild && this.renderIcon());
    }
  }]);

  return BreadcrumbItem;
}(Component);
BreadcrumbItem.propTypes = propTypes;
BreadcrumbItem.defaultProps = defaultProps;
export default BreadcrumbItem;